import { imgLogo2 } from "@/shared/assets/img";

export default function LoadingScreenLogo() {
  return <img src={imgLogo2} alt="Logo" className="h-[2.125rem] mb-auto mt-[3.75rem]" />;
}
